<div id="error" [class]="active ? 'active' : ''" [dir]="currentLang.dir">
    <div id="error-content">
        <div id="error-message">{{currentLang.words["error"]}}</div>
        <div id="error-code" [innerHTML]="error"></div>
        <div routerLink="/" (click)="close()">{{currentLang.words["reload"]}}</div>
    </div>
    <div id="error-close" (click)="close();"><span></span></div>
</div>